import { CriteriaModifierType } from 'api-models'
import { getCurrentModifier } from '../../../../utils'
import { RuleFormType } from '../../types'

export const getCurrentModifierValues = (
	modifiers: RuleFormType['modifiers'],
	criteriaType: string,
	criteriaKey: string
) => {
	const modifier = getCurrentModifier(modifiers, criteriaType)
	return modifier ? modifier[criteriaKey].values : []
}

export const getCurrentModifierValue = (
	modifiers: RuleFormType['modifiers'],
	criteriaType: string,
	criteriaKey: string
) => {
	const modifier = getCurrentModifier(modifiers, criteriaType)
	return modifier ? modifier[criteriaKey].value : []
}

export const getCurrentModifierPrimaryValue = (
	modifiers: RuleFormType['modifiers'],
	criteriaType: string,
	criteriaKey: string
) => {
	const modifier = getCurrentModifier(modifiers, criteriaType)
	if (!modifier) return null

	if (criteriaType === CriteriaModifierType.TIME)
		return modifier[criteriaKey].primary.value

	return modifier[criteriaKey].primary
}
